import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AuthModule } from './auth/auth.module';
import { LoginModule } from './login/login.module';
import { PasswordResetModule } from './password-reset/password-reset.module';
import { ServiceModule } from './service/service.module';
import { AuthInterceptor } from './service/services/auth.interceptor.service';
import { StorageModule } from './storage/storage.module';
import { UtilityModule } from './utility/utility.module';

@NgModule({
	declarations: [],
	exports: [UtilityModule, StorageModule, ServiceModule, AuthModule, LoginModule],
	imports: [UtilityModule, StorageModule, ServiceModule, AuthModule, LoginModule, PasswordResetModule],
	providers: [
		{
			multi: true,
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor
		}
	]
})
export class CoreModule {}
